<template>
  <collapse-default :id="`documentos-${ordem}`"
                    :collapse-visible="collapseVisible"
                    :condition="documentos.length">
    <template v-slot:header>
      Documentos {{ !documentos.length ? ' - Nenhum informado' : '' }}
    </template>

    <template v-slot:content>
      <div v-for="(documento, index) in documentos"
           :key="`${index}-documento`"
           class="row p-3">
        <div class="col-3">
          <label class="resumo-show_label"
                 for>Documento</label>
          <div
            class="resumo-show_sublabel">
            {{ getDocumentLabel(documento.tipo_documento) || 'Não informado' }}
          </div>
        </div>
        <div class="col-3">
          <label
            class="resumo-show_label"
            for>{{ getDocumentLabel(documento.tipo_documento) || 'Não informado' }}</label>
          <div class="resumo-show_sublabel">
            {{ documento.numero || 'Não informado' }}
          </div>
        </div>
        <div v-if="documento.uf_emissor"
             class="col-3">
          <label class="resumo-show_label"
                 for>Estado Expedidor</label>
          <div class="resumo-show_sublabel">
            {{ documento.uf_emissor || 'Não informado' }}
          </div>
        </div>
      </div>
    </template>
  </collapse-default>
</template>

<script>
  import CollapseDefault from "./CollapseDefault"
  import { getDocumentLabel } from "@/constants/documentosPessoais"


  export default {
    name: "RegistrosAnteriores",
    components: {
      CollapseDefault,
    },
    props: {
      documentos: {
        type: Array,
        default: () => ([])
      },
      collapseVisible: {
        type: Boolean,
        default: false
      },
      ordem: {
        type: Number,
        default: 1
      }
    },
    data () {
      return {
        getDocumentLabel
      }
    }
  }
</script>

<style scoped>

</style>
